import React, { useState } from 'react';
import classNames from 'classnames';
import Drawer from '@material-ui/core/Drawer';

import Button from '../Button/Button';
import HelpIcon from 'components/Common/Icons/Help';

import styles from './HelpButton.module.scss';

export default function HelpButton({ classes }: HelpButtonType): JSX.Element {
  const [openDrawer, setOpenDrawer] = useState(false);

  function handleClick() {
    setOpenDrawer(prev => !prev);
  }

  return (
    <>
      <Button className={classes?.button} onClick={handleClick}>
        <HelpIcon />
      </Button>
      <Drawer
        classes={{ paper: classNames(styles.paper, classes?.paper) }}
        open={openDrawer}
      />
    </>
  );
}

type HelpButtonType = {
  classes?: HelpButtonClassesType;
};

type HelpButtonClassesType = {
  button?: string;
  paper?: string;
};
